import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';
import { Tooltip as ReactTooltip, TooltipRefProps } from 'react-tooltip';

interface TooltipProps extends PropsWithChildren {
  id?: string;
  anchorSelect?: string;
  place?: TooltipRefProps['place'];
  className?: string;
  isDark?: boolean;
}

const Tooltip: FC<TooltipProps> = ({ id, anchorSelect, place, className, children, isDark }) => {
  return (
    <ReactTooltip
      id={id}
      anchorSelect={anchorSelect}
      place={place}
      delayShow={0}
      delayHide={0}
      classNameArrow="border-b border-r border-neutral-light"
      clickable
      className={classNames('!rounded-[4px] !opacity-100 text-[12px] !px-[24px] !py-[16px] z-30', className, {
        '!bg-white !text-neutral-dark border border-neutral-light': !isDark,
        '!bg-neutral-dark !text-white border border-neutral-dark': isDark,
      })}
    >
      <div className="flex items-center justify-between gap-1">{children}</div>
    </ReactTooltip>
  );
};

export default Tooltip;
